import { StoreActionLoggableName } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { createSafeAction, type SafeAction } from './createSafeAction';
import { getAgentMessageById } from './getAgentMessageById';
import type { ChatStoreAction } from './types';

export type UpdateActionExecutedDataArgs = {
	conversationId: string;
	messageId: string;
	invocationId: string;
	executedData: unknown;
};

export const updateActionExecutedData: SafeAction<[UpdateActionExecutedDataArgs]> =
	createSafeAction(
		StoreActionLoggableName.updateActionExecutedData,
		({
			conversationId,
			messageId,
			invocationId,
			executedData,
		}: UpdateActionExecutedDataArgs): ChatStoreAction =>
			async ({ getState }, { getMessages, setMessages }) => {
				const currentConversation = getState().conversations[conversationId];
				if (!currentConversation) {
					return;
				}

				const messages = getMessages(conversationId);
				const agentMessage = getAgentMessageById(messages, messageId);

				if (!agentMessage.result) {
					return;
				}

				const message = agentMessage.result;
				const updatedMessages = [...messages];
				updatedMessages[agentMessage.index] = {
					...message,
					content: {
						...message.content,
						message: {
							...message.content.message,
							message: {
								...message.content.message.message,
								actions: message.content.message.message.actions?.map((action) =>
									action.invocationId === invocationId ? { ...action, executedData } : action,
								),
							},
						},
					},
				};

				setMessages(conversationId, updatedMessages);
			},
	);
